import React from 'react';
import { Link } from 'react-router-dom';
import { FiFacebook, FiTwitter, FiLinkedin } from 'react-icons/fi';
import { FaApple, FaGooglePlay } from 'react-icons/fa';
import Logo from './Logo';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    // 🚀 VISIBLE ONLY ON DESKTOP (Hidden on Mobile)
    <footer className="hidden lg:block bg-[#f5f7f8] dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 text-right pt-16 font-sans text-sm" dir="rtl">

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8">

          <div>
            <h4 className="font-bold text-gray-900 dark:text-white text-base mb-4">تعلم معنا</h4>
            <ul className="space-y-3">
              <FooterLink to="/courses" label="جميع الكورسات" />
              <FooterLink to="/roadmaps" label="المسارات التعليمية" />
              <FooterLink to="/certificates" label="الشهادات المعتمدة" />
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-gray-900 dark:text-white text-base mb-4">المجتمع</h4>
            <ul className="space-y-3">
              <FooterLink to="/community" label="المنتديات" />
              <FooterLink to="/blog" label="المدونة" />
              <FooterLink to="/events" label="الفعاليات" />
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-gray-900 dark:text-white text-base mb-4">انضم إلينا</h4>
            <ul className="space-y-3">
              <FooterLink to="/teach" label="انضم كمدرب" />
              <FooterLink to="/business" label="للمؤسسات" />
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-gray-900 dark:text-white text-base mb-4">الدعم</h4>
            <ul className="space-y-3">
              <FooterLink to="/help" label="مركز المساعدة" />
              <FooterLink to="/contact" label="اتصل بنا" />
              <FooterLink to="/privacy" label="سياسة الخصوصية" />
              <FooterLink to="/terms" label="الشروط والأحكام" />
            </ul>
          </div>

          <div className="col-span-2 lg:col-span-1">
            <h4 className="font-bold text-gray-900 dark:text-white text-base mb-4">تطبيق الهاتف</h4>
            <div className="space-y-3">
              <button className="w-full flex items-center justify-center gap-2 bg-black text-white py-2 rounded-lg hover:opacity-80 transition-opacity">
                <FaApple size={20} /> App Store
              </button>
              <button className="w-full flex items-center justify-center gap-2 bg-black text-white py-2 rounded-lg hover:opacity-80 transition-opacity">
                <FaGooglePlay size={18} /> Google Play
              </button>
            </div>
          </div>

        </div>
      </div>

      <div className="bg-white dark:bg-gray-950 border-t border-gray-200 dark:border-gray-800 py-8">
        <div className="max-w-7xl mx-auto px-4 flex justify-between items-center">
          <div className="flex items-center gap-2">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-3 flex-shrink-0">
              <Logo className="h-9 w-auto" />
              <span className="font-bold text-2xl tracking-tighter text-gray-900 dark:text-white hidden xl:block">
                iTaleb<span className="text-blue-600">Tech</span>
              </span>
            </Link>
            <p className="text-gray-500 dark:text-gray-400">© {currentYear} iTalebTech. جميع الحقوق محفوظة.</p>
          </div>
          <div className="flex items-center gap-6">
            <SocialIcon icon={FiFacebook} />
            <SocialIcon icon={FiLinkedin} />
            <SocialIcon icon={FiTwitter} />
          </div>
        </div>
      </div>
    </footer>
  );
};

const FooterLink = ({ to, label }) => (
  <li><Link to={to} className="text-gray-600 dark:text-gray-400 hover:text-blue-600 block">{label}</Link></li>
);

const SocialIcon = ({ icon: Icon }) => (
  <a href="www.italebtech.com" className="text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"><Icon size={20} /></a>
);

export default Footer;